<div #originRef (click)="showPopover(originRef)" [class.bg-hover]="dropdownOpen"
  class="flex items-center rounded cursor-pointer relative trans-ease-out select-none py-1 pr-1 pl-3 hover:bg-hover"
  matRipple>
  <div class="body-1 font-medium leading-snug ltr:mr-3 rtl:ml-3" *ngIf="user" fxHide.xs>{{ user.firstName }} {{
    user.lastName }}</div>

  <net-profile-photo [width]="38" [height]="38" [fontSize]="16" [systemUser]="user"></net-profile-photo>
</div>